import { format, formatDistanceToNow } from 'date-fns';
import { uz } from 'date-fns/locale';

const DATE_FMT = 'dd MMM, HH:mm';
const SHORT_DATE = 'dd MMM';
const FULL_DATE = 'dd.MM.yyyy';

export function formatDate(iso: string | Date | null | undefined, fmt = DATE_FMT): string {
  if (!iso) return '—';
  try {
    return format(typeof iso === 'string' ? new Date(iso) : iso, fmt, { locale: uz });
  } catch {
    return '—';
  }
}

export function formatShort(iso: string | Date | null | undefined): string {
  return formatDate(iso, SHORT_DATE);
}

export function formatFull(iso: string | Date | null | undefined): string {
  return formatDate(iso, FULL_DATE);
}

export function timeAgo(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  try {
    return formatDistanceToNow(typeof iso === 'string' ? new Date(iso) : iso, {
      addSuffix: true,
      locale: uz,
    });
  } catch {
    return '—';
  }
}

export function formatUzs(amount: number | null | undefined): string {
  if (amount == null) return '0 so\'m';
  return new Intl.NumberFormat('uz-UZ').format(Math.round(amount)) + " so'm";
}

export function formatNumber(amount: number | null | undefined): string {
  if (amount == null) return '0';
  return new Intl.NumberFormat('uz-UZ').format(amount);
}
